
/* jauge tirage : a brancher sur le stock Shopify (data-total / data-reserved) */
(function(){var q=document.querySelector('.pre-q');if(!q)return;
var t=+q.dataset.total||0,r=+q.dataset.reserved||0,pc=t?Math.min(100,Math.round(r/t*100)):0;
q.querySelector('.pre-pc').textContent=pc;var bar=q.querySelector('.pre-bar');
function go(){bar.style.setProperty('--pc',pc+'%');}
if('IntersectionObserver' in window){var io=new IntersectionObserver(function(e){if(e[0].isIntersecting){go();io.disconnect();}},{threshold:.4});io.observe(bar);}else go();})();
